import React, { useState } from 'react';
import { useDarkMode } from '../context/DarkModeContext';
import { useDarkClasses } from '../hooks/useDarkClasses';
import { useRoleTheme } from '../hooks/useRoleTheme';
import { MailIcon, MessageSquareIcon, PhoneIcon, ShieldIcon, UsersIcon, CheckCircleIcon } from 'lucide-react';
const Contact = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    alert('Message sent! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      subject: 'General Inquiry',
      message: ''
    });
  };
  const subjects = ['General Inquiry', 'Author Support', 'Reader Help', 'Technical Issue', 'Partnership', 'Press'];
  return <div className={`min-h-screen py-12 ${dk.page}`} data-id="element-8337" data-mp="15fov5njbumdx">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8338" data-mp="15ex8j27pjyzs">
        {/* Header */}
        <div className="mb-12" data-id="element-8339" data-mp="19fpjbzw8aby6">
          <h1 className={`text-4xl font-bold mb-3 ${dk.textHeading}`} data-id="element-8340" data-mp="19exr8z1uawcn">
            Get in touch
          </h1>
          <p className={`text-lg ${dk.textSecondary}`} data-id="element-8341" data-mp="1j6tzh2xn42ul">
            We typically respond within one business day.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-8342" data-mp="mhmdjtt3zrq5">
          {/* Contact Info */}
          <div className="space-y-6" data-id="element-8343" data-mp="qj7kkyiypbsf">
            <div className={`p-6 rounded-xl border shadow-sm ${dk.card} ${dk.border}`} data-id="element-8344" data-mp="qk8wf57sy2b7">
              <h3 className={`font-bold mb-6 text-lg ${dk.textHeading}`} data-id="element-8345" data-mp="vjlteise0pri">
                Contact Methods
              </h3>
              <div className="space-y-6" data-id="element-8346" data-mp="26wxpu8lti63n">
                <div className="flex items-start" data-id="element-8347" data-mp="26vwcfxhbx7ir">
                  <div className={`p-2 rounded-lg mr-4 ${rt.bgMedium} ${rt.textPrimary}`} data-id="element-8348" data-mp="2buzkzrwipvvh">
                    <MailIcon className="h-5 w-5" data-id="element-8349" data-mp="1m627xe1827os" />
                  </div>
                  <div data-id="element-8350" data-mp="1h8sdtl2w17um">
                    <p className={`font-medium ${dk.textHeading}`} data-id="element-8351" data-mp="1h7h8vhxphu1x">Email</p>
                    <p className={`text-sm mb-1 ${dk.textSecondary}`} data-id="element-8352" data-mp="1w5t4rmd98ys1">
                      support@litlaunch.com
                    </p>
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${dk.isDark ? 'bg-green-900/30 text-green-400' : 'bg-green-100 text-green-800'}`} data-id="element-8353" data-mp="1r782lheg050y">
                      Usually responds in &lt; 24h
                    </span>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-8354" data-mp="18ff81ijq6br4">
                  <div className={`p-2 rounded-lg mr-4 ${rt.bgMedium} ${rt.textPrimary}`} data-id="element-8355" data-mp="18enpp9f52ais">
                    <MessageSquareIcon className="h-5 w-5" data-id="element-8356" data-mp="frb5h5wgaesn" />
                  </div>
                  <div data-id="element-8357" data-mp="fpgqe87v1gwh">
                    <p className={`font-medium ${dk.textHeading}`} data-id="element-8358" data-mp="2re4t2fp0gc7w">Live Chat</p>
                    <p className={`text-sm ${dk.textSecondary}`} data-id="element-8359" data-mp="2w5d2hbqcbxl2">
                      Available Mon-Fri, 9am-5pm EST
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-8360" data-mp="2hemb24snv0ih">
                  <div className={`p-2 rounded-lg mr-4 ${rt.bgMedium} ${rt.textPrimary}`} data-id="element-8361" data-mp="2mglgdk7yo7i2">
                    <UsersIcon className="h-5 w-5" data-id="element-8362" data-mp="3a5xki5oflpdi" />
                  </div>
                  <div data-id="element-8363" data-mp="3f2wfsrju02da">
                    <p className={`font-medium ${dk.textHeading}`} data-id="element-8364" data-mp="3f3fv00i3kcnm">
                      Community Forum
                    </p>
                    <p className={`text-sm ${dk.textSecondary}`} data-id="element-8365" data-mp="3561kehiuui38">
                      Ask questions and get answers from the community.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className={`p-6 rounded-xl border shadow-sm ${dk.card} ${dk.border}`} data-id="element-8366" data-mp="1trnyvjbkqeqd">
              <h3 className={`font-bold mb-4 text-lg ${dk.textHeading}`} data-id="element-8367" data-mp="29zbz0443uhfq">
                FAQ
              </h3>
              <p className={`text-sm mb-4 ${dk.textSecondary}`} data-id="element-8368" data-mp="2557sflyr4bf6">
                Check our Help Center for quick answers to common questions.
              </p>
              <a href="/help" className={`text-sm font-medium hover:underline ${rt.accentLink}`} data-id="element-8369" data-mp="1va60yjh06x9f">
                Visit Help Center &rarr;
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-8370" data-mp="2iyfkfeqqv8xe">
            <div className={`p-8 rounded-xl border shadow-sm ${dk.card} ${dk.border}`} data-id="element-8371" data-mp="2ixea5chjyqgq">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-8372" data-mp="2ewubu5l8tgt0">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8373" data-mp="17klgfw57bry1">
                  <div data-id="element-8374" data-mp="13i729pch9gd3">
                    <label htmlFor="name" className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-8375" data-mp="13gvu7dc01mg6">
                      Name
                    </label>
                    <input type="text" id="name" required value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} className={`w-full rounded-lg border px-4 py-2.5 focus:ring-2 ${rt.inputFocus} focus:border-transparent outline-none transition-all ${dk.input}`} data-id="element-8376" data-mp="3j75ipvnnw6dx" />
                  </div>
                  <div data-id="element-8377" data-mp="fpdveukh0am2">
                    <label htmlFor="email" className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-8378" data-mp="fnszp1mf6lmm">
                      Email
                    </label>
                    <input type="email" id="email" required value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} className={`w-full rounded-lg border px-4 py-2.5 focus:ring-2 ${rt.inputFocus} focus:border-transparent outline-none transition-all ${dk.input}`} data-id="element-8379" data-mp="3krxqobbrd74s" />
                  </div>
                </div>

                <div data-id="element-8380" data-mp="gcxxann1p6fk">
                  <label htmlFor="subject" className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-8381" data-mp="gdg0y5c1emxi">
                    Subject
                  </label>
                  <div className="relative" data-id="element-8382" data-mp="qa2k8popt5xf">
                    <select id="subject" required value={formData.subject} onChange={e => setFormData({
                    ...formData,
                    subject: e.target.value
                  })} className={`w-full rounded-lg border px-4 py-2.5 appearance-none focus:ring-2 ${rt.inputFocus} focus:border-transparent outline-none transition-all ${dk.input}`} data-id="element-8383" data-mp="ledhkdhef8ww">
                      {subjects.map(s => <option key={s} value={s} data-id="element-8384" data-mp="r04jofvpwcto">
                          {s}
                        </option>)}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none" data-id="element-8385" data-mp="h909dtgzlg56">
                      <svg className={`h-4 w-4 ${dk.textMuted}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-8386" data-mp="39ifizou3coy">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-8387" data-mp="nq3bot1o4ico" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div data-id="element-8388" data-mp="4rqssfkyfu3w">
                  <label htmlFor="message" className={`block text-sm font-medium mb-2 ${dk.textSecondary}`} data-id="element-8389" data-mp="4s8zk658tqq2">
                    Message
                  </label>
                  <textarea id="message" rows={6} required value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} className={`w-full rounded-lg border px-4 py-2.5 focus:ring-2 ${rt.inputFocus} focus:border-transparent outline-none transition-all ${dk.input}`} data-id="element-8390" data-mp="3r83dfqgmrrhu"></textarea>
                </div>

                <div className="pt-2" data-id="element-8391" data-mp="21rrd5ih9sc7b">
                  <button type="submit" className={`w-full py-3 px-4 rounded-lg font-bold text-white transition-all shadow-sm hover:shadow hover:-translate-y-0.5 ${rt.primaryButton}`} data-id="element-8392" data-mp="21on0rxtnia5k">
                    Send Message
                  </button>
                  <div className={`flex items-center justify-center mt-4 text-xs ${dk.textMuted}`} data-id="element-8393" data-mp="1dyivlm0te2cg">
                    <ShieldIcon className="h-3 w-3 mr-1.5" data-id="element-8394" data-mp="1nqydykg0wsxv" />
                    Your message is safe with us. We never share your data.
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Contact;